import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from './contexts/ThemeContext';
// Import the app directly, not through the `./oroboros` barrel: the barrel re-exports the terminal,
// docs and branding pages, whose CSS side effects would pull them into the landing's entry chunk.
import { OroborosApp } from './oroboros/OroborosApp';
import './fonts.css';
import './index.css';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Oroboros root element missing');
}

ReactDOM.createRoot(root).render(
  <ThemeProvider>
    <OroborosApp />
  </ThemeProvider>,
);
